import { Tag } from 'antd';
import { COLOR } from 'constants/colors';
import React from 'react';

interface TagProps {
    variant?: any;
    children: string | undefined | JSX.Element;
    rounded?: boolean;
    style?: React.CSSProperties,
    fontSize?: string,
    bgColor?: string

}

const CustomTag: React.FC<TagProps> = ({ variant, children, rounded, fontSize, bgColor, ...props }: TagProps) => {

    const getVariantColor = () => {
        switch (variant) {
            case 'success':
                return COLOR.GREEN;
            case 'danger':
                return COLOR.DANGER;
            case 'warning':
                return COLOR.WARNING_ORANGE;
            case 'disabled':
                return COLOR.GREY;
            default:
                return COLOR.GREY;
        }
    }
    return <Tag style={{
        color: getVariantColor(),
        borderRadius: rounded ? '12px' : '4px',
        border: 'none',
        backgroundColor: bgColor ? bgColor : '#F5F5F5',
        fontSize: `${fontSize}px`,
        whiteSpace: 'unset',
        fontWeight: 'normal',
        marginRight: '0px',   
        ...props.style
    }}>
        {children}
    </Tag>;
}

export default CustomTag;